import moment from "moment";
import mergeObjects from "lodash.assigninwith";
import { checkInRange } from "./transform";

export const getQueryParams = (fullUrl) => {
  if (!fullUrl) return "";
  let queryParams = "";
  const index = fullUrl.indexOf("?");
  if (index > -1) queryParams = fullUrl.substr(index, fullUrl.length);
  return queryParams;
};

export const getUrlParams = (search) => {
  const hashes = search.slice(search.indexOf("?") + 1).split("&");
  const params = {};
  hashes.map((hash) => {
    const [key, val] = hash.split("=");
    params[key] = decodeURIComponent(val);
  });
  return params;
};

export const checkForPrivateIP = (req, accountDetails) => {
  if (accountDetails && accountDetails.public_page_access_preferences) {
    const { privacy, allowed_ip_ranges } =
      accountDetails.public_page_access_preferences || {};

    if (
      privacy === "private" &&
      allowed_ip_ranges &&
      allowed_ip_ranges.length
    ) {
      const ipArray =
        req.headers["x-forwarded-for"] &&
        req.headers["x-forwarded-for"].split(",");
      let ipMatch = false;

      ipArray.forEach(function (ip) {
        ip = ip.trim();
        if (ip.substr(0, 7) === "::ffff:") {
          ip = ip.substr(7);
        }
        ip = ip.split(":")[0]; //split by colon to remove port
        if (checkInRange(ip, allowed_ip_ranges)) {
          ipMatch = true;
        }
      });

      if (!ipMatch) {
        const err: any = new Error(
          "IP not in given range when accessing for host => " +
            req.headers["host"]
        );
        err.code = "ENOENT";
        throw err;
      }
    }
  }
};

export const getComponentsByGroup = (affected_components, components) => {
  const componentsByGroupArr: any = new Map();
  const nogroupComponents: any = [];
  if (affected_components && affected_components.length) {
    for (let i = 0; i < affected_components.length; i++) {
      const filteredComponent = components.find(
        (component) => component.id == affected_components[i].component
      );

      if (filteredComponent !== undefined) {
        const tempComponent: any = {
          id: filteredComponent.id,
          name: filteredComponent.name,
          status: affected_components[i].new_status,
        };

        if (filteredComponent.group_id == null) {
          nogroupComponents.push(tempComponent);
        } else {
          const groupId = filteredComponent.group_id;
          if (componentsByGroupArr[groupId] !== undefined) {
            componentsByGroupArr[groupId].push(tempComponent);
          } else {
            componentsByGroupArr[groupId] = [tempComponent];
          }
        }
      }
    }

    if (nogroupComponents.length) {
      componentsByGroupArr[""] = nogroupComponents;
    }
    return componentsByGroupArr;
  }
};

export const filterComponentsList = (componentsList) => {
  const filterGroupsBasedOnParams = (
    components,
    params,
    filteredComponents
  ) => {
    components.forEach((component) => {
      if (component.components && component.parent == null) {
        // group found
        const paramsGroups = params.groups.split(",");
        if (paramsGroups.indexOf(component.name) > -1) {
          // filter groups present in query param
          filteredComponents.push(component);
        }
      }
    });
    return filteredComponents;
  };

  const filterSubGroupsBasedOnParams = (
    components,
    params,
    filteredComponents
  ) => {
    components.forEach((component) => {
      if (component.components) {
        if (component.parent != null) {
          // subgroup found
          const paramsSubGroups = params.subgroups.split(",");
          if (paramsSubGroups.indexOf(component.name) != -1) {
            // filter subgroups present in query param
            filteredComponents.push(component);
          }
        } else {
          // group found; iterate
          var filteredComponent = JSON.parse(JSON.stringify(component));
          var componentsArray = filterSubGroupsBasedOnParams(
            component.components,
            params,
            []
          );
          if (componentsArray.length > 0) {
            filteredComponent.components = componentsArray;
            filteredComponents.push(filteredComponent);
          }
        }
      }
    });
    return filteredComponents;
  };

  const filterComponentsBasedOnParams = (
    components,
    params,
    filteredComponents
  ) => {
    components.forEach((component) => {
      if (component.components) {
        // group found; iterate
        var filteredComponent = JSON.parse(JSON.stringify(component));
        var componentsArray = filterComponentsBasedOnParams(
          component.components,
          params,
          []
        );
        if (componentsArray.length > 0) {
          filteredComponent.components = componentsArray;
          filteredComponents.push(filteredComponent);
        }
      } else {
        const paramsServices = params.services.split(",");
        if (paramsServices.indexOf(component.name) > -1) {
          // filter components present in query param
          filteredComponents.push(component);
        }
      }
    });
    return filteredComponents;
  };

  // build all components array from componentsList
  const getComponents: any = (components: any = [], filteredComponentsData) => {
    components.forEach((component) => {
      if (component.components) {
        // group found; iterate till the root nodes and return the component
        filteredComponentsData.filteredComponentGroups.push(component);
        filteredComponentsData = getComponents(
          component.components,
          filteredComponentsData
        );
      } else {
        filteredComponentsData.filteredComponents.push(component);
      }
    });
    return filteredComponentsData;
  };
  const getSuperlativeStatus = (statusArray: string[]) => {
    let status = ["MO", "PO", "PD", "UM"].find(
      (status) => statusArray.indexOf(status) > -1
    );
    return status ? status : "OP";
  };
  const componentsListStatus: any = (componentsList) => {
    componentsList = componentsList.map((region) => {
      let statusArr: string[] = [];
      if (region.components) {
        region.components.forEach((service) => {
          if (service.status !== "OP") statusArr.push(service.status);
        });
        region.status = getSuperlativeStatus(statusArr);
      } else {
        region.status = region.status;
      }

      let name;
      if (
        region.name === "US EAST (NORTH VIRGINIA)" ||
        region.name === "US EAST"
      ) {
        name = "US";
      } else if (
        region.name === "EU CENTRAL(FRANKFURT)" ||
        region.name === "EU CENTRAL" ||
        region.name.includes("EUC") ||
        region.name === "EU CENTRAL (FRANKFURT)"
      ) {
        name = "EUC";
      } else if (
        region.name === "ASIA PACIFIC (SYDNEY)" ||
        region.name === "ASIA PACIFIC ( SYDNEY)" ||
        region.name === "ASIA PACIFIC (AU)" ||
        region.name.includes("SYDNEY") ||
        region.name.includes("AU") ||
        region.name.includes("AUS")
      ) {
        name = "AUS";
      } else if (
        region.name === "ASIA PACIFIC (MUMBAI)" ||
        region.name === "ASIA PACIFIC (INDIA)" ||
        region.name.includes("IND") ||
        region.name.includes("INDIA") ||
        region.name.includes("MUMBAI")
      ) {
        name = "IND";
      } else {
        name = region.name;
      }
      region.regionName = name;

      return region;
    });
    return componentsList;
  };

  // if (isFilterComponents) {
  //   if (params.groups && params.groups.length > 0 && params.groups != 'all') {
  //     componentsList = filterGroupsBasedOnParams(componentsList, params, []);
  //   }
  //   if (
  //     params.subgroups &&
  //     params.subgroups.length > 0 &&
  //     params.subgroups != 'all'
  //   ) {
  //     componentsList = filterSubGroupsBasedOnParams(componentsList, params, []);
  //   }
  //   if (
  //     params.services &&
  //     params.services.length > 0 &&
  //     params.services != 'all'
  //   ) {
  //     componentsList = filterComponentsBasedOnParams(
  //       componentsList,
  //       params,
  //       []
  //     );
  //   }
  // }
  let filteredComponentsData: any = getComponents(componentsList, {
    filteredComponents: [],
    filteredComponentGroups: [],
  });
  componentsList = componentsListStatus(componentsList);
  return {
    filteredComponentsList: componentsList,
    filteredComponentGroups: filteredComponentsData.filteredComponentGroups,
    filteredComponents: filteredComponentsData.filteredComponents,
  };
};

export const getIncidentDetails = (incidents = [], timezone, componentId) => {
  let incidentsData: any = [];
  incidentsData = incidents.map((eachInc: any) => {
    const affectedComponent =
      eachInc &&
      eachInc.affected_components &&
      eachInc.affected_components.find(
        (cmp) => `${cmp.component}` === `${componentId}`
      );
    return {
      iconUrl:
        affectedComponent &&
        affectedComponent.new_status &&
        COMP_STATUSES[affectedComponent.new_status].iconUrl,
      timezone,
      ...eachInc,
    };
  });
  return incidentsData || [];
};

export const getDropdownItems = (components, componentGroups) => {
  const componentData: any = getComponentsData(components, componentGroups);
  const finalItems: any = [];
  componentData.forEach((comp) => {
    const { children = [], ...rest } = comp;
    finalItems.push(rest);
    children.forEach((lev2) => {
      const { children: children2 = [], ...rest2 } = lev2;
      finalItems.push(rest2);
      children2.forEach((lev3) => {
        finalItems.push(lev3);
      });
    });
  });
  return finalItems;
};

export const getComponentsData = (components, componentGroups) => {
  const lev1Components =
    (components.length &&
      components
        .filter((comp) => comp.group === null || comp.group_id === null)
        .map((comp) => ({
          ...comp,
          isGroup: false,
          isSubGroup: false,
          level: 1,
        }))) ||
    [];
  const lev1Groups =
    (componentGroups &&
      componentGroups.length &&
      componentGroups
        .filter((compGrp) => compGrp.parent === null)
        .map((comp) => ({
          ...comp,
          isGroup: true,
          isSubGroup: false,
          level: 1,
        }))) ||
    [];
  const lev1Items = [...lev1Components, ...lev1Groups]
    .sort((a, b) => a.order - b.order)
    .map((item) => {
      const lev2Components = components
        .filter(
          (comp) =>
            (comp.group && comp.group === item.id) ||
            (comp.group_id && comp.group_id === item.id)
        )
        .map((comp) => ({
          ...comp,
          isGroup: false,
          isSubGroup: false,
          level: 2,
        }));
      const lev2Groups = componentGroups
        .filter((compGrp) => compGrp.parent && compGrp.parent === item.id)
        .map((comp) => ({
          ...comp,
          isSubGroup: true,
          isGroup: true,
          level: 2,
        }));
      const lev2Items = [...lev2Components, ...lev2Groups]
        .sort((a, b) => a.order - b.order)
        .map((subItem) => {
          const lev3Components = components
            .filter(
              (comp) =>
                (comp.group && comp.group === subItem.id) ||
                (comp.group_id && comp.group_id === subItem.id)
            )
            .sort((a, b) => a.order - b.order)
            .map((comp) => ({
              ...comp,
              isGroup: false,
              isSubGroup: false,
              level: 3,
            }));
          return {
            ...subItem,
            children: lev3Components,
          };
        });
      return {
        ...item,
        children: lev2Items,
      };
    });
  return lev1Items;
};

const getSubscribedComponentsFromGroup = (
  subscribed_groups,
  componentsGroup
) => {
  const componentIds: any = [];
  subscribed_groups.forEach((subscribed_group_id) => {
    const group: any =
      componentsGroup &&
      componentsGroup.find(
        (eachGroup) => eachGroup.id === Number(subscribed_group_id)
      );
    if (group) {
      group.components.forEach((component) => {
        if (component.components) {
          // if sub-group
          if (subscribed_groups.includes(component.id)) {
            /* this is because sometimes admin will include both the group_id and sub_group_id in data.subscribed_groups which should only be group_id since it included sub_group_id in itself.
            so we need to check if the sub_group_id is already in the array or not. If yes then we will not add it here.
            If the above behaviour is fixed in admin then we could remove this if condition */
            return;
          }
          component.components.forEach((eachComponent) => {
            componentIds.push(eachComponent.id.toString());
          });
        } else {
          componentIds.push(component.id.toString());
        }
      });
    } else {
      componentsGroup.forEach((eachGroup) => {
        if (eachGroup.components) {
          const subGroup = eachGroup.components.find(
            (subgroup) => subgroup.id === Number(subscribed_group_id)
          );
          if (subGroup && subGroup.components) {
            subGroup.components.forEach((component) => {
              componentIds.push(component.id.toString());
            });
          }
        }
      });
    }
  });
  return componentIds;
};

export const COMP_STATUSES = {
  MO: {
    name: "Major Outage",
    iconUrl: "/icons/cross.svg",
  },
  OP: {
    name: "Operational",
    iconUrl: "/icons/tick.svg",
  },
  PO: {
    name: "Partial Outage",
    iconUrl: "/icons/partial.svg",
  },
  PD: {
    name: "Degraded Performance",
    iconUrl: "/icons/degraded.svg",
  },
  UM: {
    name: "Under Maintenance",
    iconUrl: "/icons/maintenance.svg",
  },
};

const getHistoryData = (state) => {
  const {
    // eslint-disable-next-line no-unused-vars
    duration_seconds_by_state: { OP = 0, ...duration },
    availability_percentage: availability,
  } = state;
  const output: any = [];
  Object.keys(duration).forEach((key) => {
    if (duration[key] > 0 && availability !== 100) {
      let str = "";
      const hrs = Math.floor(duration[key] / 3600);
      const mins = Math.floor((duration[key] % 3600) / 60);
      if (hrs > 0) {
        str += `${hrs} ${hrs > 1 ? "Hrs " : "Hr "}`;
      }
      str += `${mins} ${mins > 1 ? "Mins" : "Min"}`;
      output.push({
        id: key,
        name: COMP_STATUSES[key].name || "Outage",
        iconUrl: COMP_STATUSES[key].iconUrl || "",
        time: str.trim(),
      });
    }
  });
  return output;
};

const getBalloonString = (history) =>
  `${moment(new Date(history)).format("MMMM DD")}`;

const getDatesInRange = (bar_timespan_hours, graph_timespan_days) => {
  let days: any = [];
  const tonight = moment().add(1, "day").startOf("day").format(); // consider tonight end time to calculate the previous days
  const now = Date.now();
  for (
    let i = (graph_timespan_days + 1) * (24 / bar_timespan_hours);
    i > 0;
    i--
  ) {
    // calculate start time
    const start_time = moment(tonight)
      .subtract(i * bar_timespan_hours * 60, "minutes")
      .startOf("minute")
      .utc()
      .format();
    // if start_time is less than now; push this to days
    if ((new Date(start_time) as any) - now < 0) {
      let end_time = moment(start_time)
        .add(bar_timespan_hours * 60, "minutes")
        .utc()
        .format();
      // if end_time is more than now; consider now time
      // if (new Date(end_time) - now >= 0) end_time = moment().utc().format();
      days.push({
        start: start_time,
        end: end_time,
      });
    }
  }
  // remove old records
  days = days.splice(
    days.length - (graph_timespan_days / bar_timespan_hours) * 24,
    days.length
  );
  return days;
};
const combineStatusDuration = (a = {}, b = {}) => ({
  OP: (a["OP"] + b["OP"]) / 2,
  PD: (a["PD"] + b["PD"]) / 2,
  PO: (a["PO"] + b["PO"]) / 2,
  MO: (a["MO"] + b["MO"]) / 2,
});

const consolidateComponentHistoryForGroup = (
  bar_timespan_hours,
  graph_timespan_days,
  affectedHistory
) => {
  let days = getDatesInRange(bar_timespan_hours, graph_timespan_days);
  let combinedStatus = mergeObjects(
    {},
    ...Object.keys(affectedHistory).map((eachComp) => {
      return affectedHistory[eachComp];
    }),
    (objValue, sourceValue, key, object, source) => {
      if (!object[key]) {
        return sourceValue;
      }
      const combinedDuration = combineStatusDuration(
        object[key]["duration_seconds_by_state"],
        source[key]["duration_seconds_by_state"]
      );
      const combinedIncidents = (object[key].incidents || []).concat(
        source[key].incidents || []
      );
      return {
        ...object[key],
        duration_seconds_by_state: combinedDuration,
        incidents: combinedIncidents,
      };
    }
  );
  return days.map((eachDay, index) => {
    return {
      ...eachDay,
      availability_percentage: 100,
      duration_seconds_by_state: {
        OP: 24 * 60 * 60,
        PD: 0,
        MO: 0,
        PO: 0,
        UM: 0,
      },
      ...combinedStatus[index],
    };
  });
};
export {
  getBalloonString,
  getHistoryData,
  getDatesInRange,
  getSubscribedComponentsFromGroup,
  consolidateComponentHistoryForGroup,
};
